require('./RAPortfolioSelector.scss');

const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { formatText } = require('core/i18n').i18n;

class RAPortfolioSelector extends React.Component {
    render() {
        const {
            options,
            onChangeOption,
            selectedPortfolio,
            isEvolutionModal,
            isFromNewContribution,
        } = this.props;

        const modalOptions = options.entrySeq().map(entry => {
            const portfolioID = entry[0];
            const portfolioName = entry[1].get('name');
            let goalDateExpired;

            if (isFromNewContribution && entry[1].get('hasGoal')) {
                const goalDate = entry[1].getIn([
                    'goalInformation',
                    'goalDate',
                ]);
                goalDateExpired = moment(goalDate).isSameOrBefore(
                    moment(),
                    'day',
                );
            }

            return {
                value: portfolioID,
                label: portfolioName,
                disabled: goalDateExpired,
            };
        });

        const optionsModal = modalOptions && modalOptions.toJS();

        if (isEvolutionModal) {
            optionsModal.push({
                value: '0',
                label: formatText(
                    'raPortfolioSelector-raPortfolioSelector_allPortfolios',
                ),
            });
        }

        const placeholder = formatText(
            'raPortfolioSelector-raPortfolioSelector_placeholder',
        );

        return (
            <div className="ra-portfolio-selector">
                <OKSelect
                    clearable={false}
                    onChange={onChangeOption}
                    options={optionsModal}
                    value={selectedPortfolio}
                    searchable={false}
                    placeholder={placeholder}
                />
            </div>
        );
    }
}

RAPortfolioSelector.propTypes = {
    isEvolutionModal: PropTypes.bool,
    isFromNewContribution: PropTypes.bool,
    onChangeOption: PropTypes.func.isRequired,
    options: PropTypes.object.isRequired,
    selectedPortfolio: PropTypes.string.isRequired,
};

RAPortfolioSelector.defaultProps = {
    isEvolutionModal: false,
    isFromNewContribution: false,
};

module.exports = RAPortfolioSelector;
